import { Field } from 'formik';
import * as React from 'react';

import { RadioFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function RadioField(props: RadioFieldProps) {
    const {
        fieldSize,
        name,
        label,
        placeholder,
        options,
        disabled,
        customOnChange,
        errors
    } = props;

    const classes = muiStyles(props);

    return (
        <Field
            name={name}
        >
            {({ field, form }) => (
                <div className={classes.radioField}>
                    <label
                        className={fieldSize === 'large' ? classes.inputLabelLarge : classes.inputLabel}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                    <div className={classes.radioContainer}>
                        {options.map((option) => (
                            <div
                                className={classes.radioOptionContainer}
                                key={option.value.toString()}
                            >
                                <div className={classes.inputContainer}>
                                    <input
                                        checked={field.value.toString() === option.value.toString()}
                                        className={classes.radioInput}
                                        disabled={disabled}
                                        name={name}
                                        onChange={(e) => {
                                            if (!form.touched[name]) {
                                                form.setFieldTouched(name, true);
                                            }

                                            if (customOnChange) {
                                                customOnChange(e);
                                            } else {
                                                field.onChange(e);
                                            }
                                        }}
                                        placeholder={placeholder}
                                        type='radio'
                                        value={option.value}
                                    />
                                </div>
                                <label
                                    className={classes.radioLabel}
                                    htmlFor={option.label}
                                >
                                    {option.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    <ErrorMessage
                        error={errors[field.name]}
                        field={field}
                        form={form}
                    />
                </div>
            )}
        </Field>
    );
}